import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

interface MetaProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  ogType?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  forceCanonical?: boolean;
  children?: React.ReactNode;
}

const Meta: React.FC<MetaProps> = ({
  title,
  description,
  canonicalUrl,
  ogType = 'website',
  ogTitle,
  ogDescription,
  ogImage,
  forceCanonical = false,
  children
}) => {
  const siteUrl = 'https://homeworkguy.org';
  // Ensure we have a valid canonical URL by constructing it if not provided
  const fullCanonicalUrl = canonicalUrl 
    ? (canonicalUrl.startsWith('http') ? canonicalUrl : `${siteUrl}${canonicalUrl}`) 
    : `${siteUrl}${window.location.pathname}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {(forceCanonical || canonicalUrl) && <link rel="canonical" href={fullCanonicalUrl} />}
      
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonicalUrl} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || title} />
      <meta name="twitter:description" content={ogDescription || description} />
      <meta name="twitter:domain" content="homeworkguy.org" />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      
      {children}
    </Helmet>
  );
};

export default Meta; 